<dgx-profile-global-styles></dgx-profile-global-styles>

<div *ngIf="usingReducedTracking" class="reduce-tracking-enabled"></div>

<dgx-skip-nav
  containerName="profile-content"
  [linkText]="i18n.dgSkipNav_SkipSubNavigation"
></dgx-skip-nav>

<ng-container *ngIf="!isLoading">
  <!-- Private Profile, trying to access settings, fire onActivate so the logged out settings page can load-->
  <div class="center-item" *ngIf="options.viewerIsBlocked && isSettingsPage">
    <div class="grid__col-12 grid__col--bleed">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
  </div>

  <!-- Private Profile -->

  <div class="center-item" *ngIf="options.viewerIsBlocked && !isSettingsPage">
    <div class="center-text guts-p-full-2 empty-profile">
      <img
        class="not-too-wide"
        [src]="options.learnTypesBlob"
        [alt]="'UserController_TrackLearningAltTag' | translate"
      />
      <div class="empty-profile-content">
        <div
          class="round alpha bg-color-ebony-a18 color-ebony-a61 ib lock-container"
        >
          <df-icon icon="lock"></df-icon>
        </div>
        <p
          class="delta color-ebony-a61 guts-m-t-1-half guts-p-b-0"
          [innerHTML]="'UserController_PrivateProfile' | translate"
        ></p>
        <p
          class="delta color-ebony-a61 guts-m-t-half"
          [innerHTML]="'UserController_PrivateProfileExplanation' | translate"
        ></p>
      </div>
    </div>
  </div>
  <!-- Main Profile Content -->
  <div
    class="center-item"
    *ngIf="!options.viewerIsBlocked"
    data-dgprop-location="Profile"
    [class.scrollable]="isMobile"
  >
    <ng-container *ngIf="hasProfileHeader">
      <div class="grid__col-12 guts-p-v-0 guts-m-b-2">
        <div class="banner-overlay bg-color-ebony-a03"></div>
        <dgx-user-info [profile]="profile" [options]="options"></dgx-user-info>

        <div class="guts-p-l-1-half" *ngIf="!hideNavigation">
          <dgx-tab-navigation
            *ngIf="hasTabNavigation"
            [tabList]="tabList"
            [underlineSelectedTabOnly]="true"
            [queryParamsHandling]="'preserve'"
            [wrapperClasses]="
              isMobile
                ? 'guts-p-b-0 tabnavs--dark-background profile-navigation-wrapper--mobile'
                : 'guts-p-b-0 tabnavs--dark-background profile-navigation-wrapper'
            "
          ></dgx-tab-navigation>
        </div>
      </div>
    </ng-container>

    <div class="grid__col-12 grid__col--bleed" id="profile-content">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
  </div>
</ng-container>
